<mat-card>
  <mat-card-content>
    <form [formGroup]="form" fxLayout="column" fxLayoutGap="20px">
      <fieldset fxFlex="100%">
        <legend>Situação</legend>

        <div fxLayout="column" fxLayoutGap="5px">
          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>Unidade</mat-label>
              <input matInput [value]="inscricaoSituacao?.concursoCampus" [disabled]="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Concurso</mat-label>
              <input matInput [value]="inscricaoSituacao?.concursoTitulo" [disabled]="true" />
            </mat-form-field>
          </div>

          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>CPF</mat-label>
              <input matInput [value]="inscricaoSituacao?.candidatoCpf" [disabled]="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Nome</mat-label>
              <input matInput [value]="inscricaoSituacao?.nomeSocial || inscricaoSituacao?.nome" [disabled]="true" />
            </mat-form-field>
          </div>

          <mat-divider></mat-divider>

          <div fxLayout.gt-md="row" fxLayoutGap="20px" fxFill>
            <mat-form-field appearance="outline">
              <mat-label>Data</mat-label>
              <input
                matInput
                [value]="inscricaoSituacao?.statusData | date : 'dd/MM/yyyy HH:mm:ss'"
                name="statusData"
                [disabled]="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Usuário</mat-label>
              <input matInput [value]="inscricaoSituacao?.statusUsuario" name="statusUsuario" [disabled]="true" />
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Concluído</mat-label>
              <input
                matInput
                [value]="inscricaoSituacao?.statusConcluida ? 'Sim' : 'Não'"
                name="statusConcluida"
                [disabled]="true" />
            </mat-form-field>
          </div>

          <mat-divider></mat-divider>
          <mat-card class="warn">
            Os campos "Situação, Motivo e Validade de documento de jurado" só podem ser preenchidos / alterados após o término das inscrições.
          </mat-card>

          <mat-form-field appearance="outline" >
            <mat-label>Situação</mat-label>
            <mat-select name="status" formControlName="status">
              <mat-option *ngFor="let type of situacoesDisponiveis | keyvalue" [value]="type.key">
                {{ type.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Motivo</mat-label>
            <input matInput formControlName="statusMotivo" name="statusMotivo" />
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="inscricao?.jurado">
            <mat-label>Validade do documento de jurado</mat-label>
            <mat-hint>Este campo é somente para indicar aos examinadores e presidente se o candidato deve ser considerado como tendo sido jurado ou não</mat-hint>
            <mat-select name="documentoJuradoInvalido" formControlName="documentoJuradoInvalido">
              <mat-option [value]="null" disabled>Aguardando análise</mat-option>
              <mat-option value="false">Válido</mat-option>
              <mat-option value="true">Inválido</mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('documentoJuradoInvalido')?.hasError('required')">Campo obrigatório</mat-error>
          </mat-form-field>
        </div>
      </fieldset>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div
      fxLayoutAlign.gt-md="space-between center"
      fxLayoutAlign.lt-md="center stretch"
      fxLayout.lt-md="column"
      fxLayoutGap="20px">
      <ng-container *ngIf="isPermitirAlteracao; then permitirAlteracaoBtn; else atualizarBtns"></ng-container>
      <ng-template #permitirAlteracaoBtn>
        <button
          mat-raised-button
          color="primary"
          (click)="permitirAlteracao()"
          [disabled]="!inscricaoSituacao?.statusConcluida">
          <mat-icon>edit</mat-icon> Reverter
        </button>
        <app-back-button routerLink="../.." color="warn"></app-back-button>
      </ng-template>
      <ng-template #atualizarBtns>
        <button mat-raised-button color="primary" (click)="gravar()" [disabled]="inscricaoSituacao?.statusConcluida || !inscricaoSituacao?.concursoAposPeriodoInscricao">
          <mat-icon>edit</mat-icon> Atualizar
        </button>
        <app-cancel-button (cancel)="cancelar.emit()"></app-cancel-button>
      </ng-template>
    </div>
  </mat-card-actions>
</mat-card>
